import { IsBoolean, IsNotEmpty } from '@pristine-ts/class-validator';
import { ErrorMessageBuilder } from '../../../../../../common/src/builders/error-message.builder';

export class RolloverPropertyTransferredSection85_2_1Result {
  // BooleanType
  @IsBoolean({ buildErrorMessage: ErrorMessageBuilder.build })
  @IsNotEmpty({ buildErrorMessage: ErrorMessageBuilder.build })

  isApplicable: boolean;
}